const security = {
    page_title: 'Seguridad',
    title: 'Seguridad',
    subtitle: 'Configura una protección avanzada contra ataques sofisticados.',
    tabs: {
        captcha: 'CAPTCHA',
        password_policy: 'Política de contraseña',
        blocklist: 'Lista de bloqueados',
        general: 'General',
    },
    bot_protection: {
        title: 'Protección contra bots',
        description: 'Habilita el CAPTCHA para registrarse, iniciar sesión y recuperar la contraseña para bloquear amenazas automatizadas.',
        captcha: {
            title: 'CAPTCHA',
            placeholder: 'Selecciona un proveedor de CAPTCHA y configura la integración.',
            add: 'Agregar CAPTCHA',
        },
        settings: 'Configuraciones',
        enable_captcha: 'Habilitar CAPTCHA',
        enable_captcha_description: 'Habilita la verificación CAPTCHA para los procesos de registro, inicio de sesión y recuperación de contraseña.',
    },
    create_captcha: {
        setup_captcha: 'Configurar CAPTCHA',
    },
    captcha_providers: {
        recaptcha_enterprise: {
            name: 'reCAPTCHA Enterprise',
            description: 'La solución CAPTCHA de nivel empresarial de Google, que proporciona detección avanzada de amenazas y análisis de seguridad detallados para proteger tu sitio web contra actividades fraudulentas.',
        },
        turnstile: {
            name: 'Cloudflare Turnstile',
            description: 'La alternativa inteligente de CAPTCHA de Cloudflare que proporciona protección contra bots no intrusiva mientras garantiza una experiencia de usuario fluida sin acertijos visuales.',
        },
    },
    captcha_details: {
        back_to_security: 'Volver a seguridad',
        page_title: 'Detalles de CAPTCHA',
        check_readme: 'Ver README',
        options_change_captcha: 'Cambiar proveedor de CAPTCHA',
        connection: 'Conexión',
        description: 'Configura tus conexiones de captcha.',
        site_key: 'Clave del sitio',
        secret_key: 'Clave secreta',
        project_id: 'ID del proyecto',
        domain: 'Dominio (opcional)',
        domain_placeholder: 'www.google.com (predeterminado) o recaptcha.net',
        recaptcha_key_id: 'ID de la clave reCAPTCHA',
        recaptcha_api_key: 'Clave API del proyecto',
        deletion_description: '¿Estás seguro de que quieres eliminar este proveedor de CAPTCHA?',
        captcha_deleted: 'Proveedor de CAPTCHA eliminado con éxito',
        setup_captcha: 'Configurar CAPTCHA',
        mode: 'Modo de verificación',
        mode_invisible: 'Invisible',
        mode_checkbox: 'Casilla de verificación',
        mode_notice: 'El modo de verificación se define en la configuración de tu clave reCAPTCHA en Google Cloud Console. Cambiar el modo aquí requiere un tipo de clave coincidente.',
    },
    password_policy: {
        password_requirements: 'Requisitos de contraseña',
        password_requirements_description: 'Mejora los requisitos de contraseña para defenderse contra ataques de relleno de credenciales y contraseñas débiles.',
        minimum_length: 'Longitud mínima',
        minimum_length_description: 'NIST sugiere usar <a>al menos 8 caracteres</a> para productos web.',
        minimum_length_error: 'La longitud mínima debe estar entre {{min}} y {{max}} (inclusive).',
        minimum_required_char_types: 'Tipos de caracteres requeridos mínimos',
        minimum_required_char_types_description: 'Tipos de caracteres: mayúsculas (A-Z), minúsculas (a-z), números (0-9) y símbolos especiales ({{symbols}}).',
        password_rejection: 'Rechazo de contraseña',
        compromised_passwords: 'Contraseñas comprometidas',
        breached_passwords: 'Contraseñas vulneradas',
        breached_passwords_description: 'Rechazar contraseñas encontradas previamente en bases de datos de vulnerabilidad.',
        restricted_phrases: 'Restringir frases de baja seguridad',
        restricted_phrases_tooltip: 'Su contraseña debe evitar estas frases a menos que combine con 3 o más caracteres adicionales.',
        repetitive_or_sequential_characters: 'Caracteres repetitivos o secuenciales',
        repetitive_or_sequential_characters_description: 'Por ejemplo, "AAAA", "1234" y "abcd".',
        user_information: 'Información de usuario',
        user_information_description: 'Por ejemplo, dirección de correo electrónico, número de teléfono, nombre de usuario, etc.',
        custom_words: 'Palabras personalizadas',
        custom_words_description: 'Personaliza las palabras específicas del contexto, sin importar las mayúsculas y minúsculas, y una por línea.',
        custom_words_placeholder: 'Nombre de su servicio, nombre de la empresa, etc.',
        password_expiration: 'Expiración de contraseña',
        password_expiration_description: 'Requerir a los usuarios que restablezcan su contraseña después de un número determinado de días. Los usuarios que inician sesión a través de SSO o clave de acceso no se ven afectados.',
        enable_password_expiration: 'Habilitar expiración de contraseña',
        enable_password_expiration_description: 'Requerir a los usuarios que restablezcan periódicamente su contraseña. Los usuarios existentes sin una fecha de cambio de contraseña registrada serán evaluados a partir de la fecha en que se habilitó esta política.',
        enable_password_expiration_tip: 'Solo puedes habilitar la expiración de contraseña después de configurar al menos un método de recuperación de contraseña con un conector válido en la experiencia de inicio de sesión.',
        expiration_period: 'Periodo de validez de la contraseña (dias)',
        expiration_period_description: 'Número de días que una contraseña permanece válida antes de expirar.',
        expiration_period_error: 'El período de validez de la contraseña debe estar entre {{min}} y {{max}} días.',
        password_expiration_recovery_reminder: 'Es posible que algunos usuarios no tengan una dirección de correo electrónico o un número de teléfono para recibir un código de recuperación de contraseña, por lo que no podrán restablecer una contraseña caducada. Exige una dirección de correo electrónico o un número de teléfono en el registro para asegurarte de que todos los usuarios puedan recuperar su contraseña.',
    },
    verification_code_policy: {
        card_title: 'Código de verificación',
        card_description: 'Configura la duración de expiración y el número máximo de reintentos para los códigos de verificación usados en los flujos de inicio de sesión, registro y restablecimiento de contraseña.',
        enable: {
            title: 'Personalizar ajustes del código de verificación',
            description: 'Permitir la personalización de la duración de expiración del código de verificación y el número máximo de reintentos.',
        },
        expiration_duration: {
            title: 'Duración de expiración (segundos)',
            description: 'La duración en segundos durante la cual un código de verificación permanece válido después de enviarse.',
            error_message: 'La duración de expiración debe estar entre 60 y 3600 segundos.',
        },
        max_retry_attempts: {
            title: 'Número máximo de reintentos',
            description: 'Número máximo de intentos de verificación fallidos permitidos antes de invalidar el código.',
            error_message: 'El número máximo de reintentos debe estar entre 1 y 100.',
        },
    },
    sentinel_policy: {
        card_title: 'Bloqueo de identificador',
        card_description: 'El bloqueo está disponible para todos los usuarios con la configuración predeterminada, pero puedes personalizarlo para tener más control.\n\nBloquea temporalmente un identificador después de múltiples intentos fallidos de autenticación (por ejemplo, contraseña o código de verificación incorrecto consecutivos) para evitar el acceso por fuerza bruta.',
        enable_sentinel_policy: {
            title: 'Personalizar experiencia de bloqueo',
            description: 'Permitir la personalización de los intentos de inicio de sesión fallidos máximos antes del bloqueo, la duración del bloqueo y el desbloqueo manual inmediato.',
        },
        max_attempts: {
            title: 'Máximos intentos fallidos',
            description: 'Bloquea temporalmente un identificador después de alcanzar el número máximo de intentos fallidos de inicio de sesión en una hora.',
            error_message: 'Los máximos intentos fallidos deben ser mayores que 0.',
        },
        lockout_duration: {
            title: 'Duración del bloqueo (minutos)',
            description: 'Bloquear inicios de sesión por un periodo después de exceder el límite de intentos fallidos.',
            error_message: 'La duración del bloqueo debe ser al menos de 1 minuto.',
        },
        manual_unlock: {
            title: 'Desbloqueo manual',
            description: 'Desbloquear usuarios inmediatamente confirmando su identidad e ingresando su identificador.',
            unblock_by_identifiers: 'Desbloquear por identificador',
            modal_description_1: 'Un identificador se bloqueó temporalmente debido a múltiples intentos de inicio/registro fallidos. Para proteger la seguridad, el acceso se restaurará automáticamente después de la duración del bloqueo.',
            modal_description_2: ' Solo desbloquear manualmente si has confirmado la identidad del usuario y asegurado que no hubo intentos de acceso no autorizados.',
            placeholder: 'Ingresa identificadores (correo electrónico / número de teléfono / nombre de usuario)',
            confirm_button_text: 'Desbloquear ahora',
            success_toast: 'Desbloqueado con éxito',
            duplicate_identifier_error: 'Identificador ya agregado',
            empty_identifier_error: 'Por favor, ingresa al menos un identificador',
        },
    },
    blocklist: {
        card_title: 'Lista de bloqueo de correos electrónicos',
        card_description: 'Toma el control de tu base de usuarios al bloquear direcciones de correo electrónico de alto riesgo o no deseadas.',
        custom_email_allowlist: {
            title: 'Permitir direcciones de correo personalizadas',
            description: 'Agrega reglas para permitir solo dominios de correo, direcciones de correo o patrones comodín específicos para nuevos registros y correos vinculados recientemente. Ejemplos: bar@example.com, @example.com, foo*@example.com, *@example.com. Los dominios gmail.com y googlemail.com se tratan como equivalentes y los puntos de la parte local se ignoran, por lo que foo.bar@gmail.com coincide con foobar@googlemail.com.',
            placeholder: 'Ingresa una dirección de correo, dominio o patrón comodín',
            duplicate_error: 'La dirección de correo, dominio o patrón comodín ya se agregó',
            invalid_format_error: 'Debe ser una dirección de correo válida (bar@example.com), un dominio (@example.com) o un patrón comodín (foo*@example.com, *@example.com)',
            warnings: {
                identical_entries: 'Algunas entradas de la lista de permitidos también existen en las reglas de bloqueo. Los correos coincidentes aún pueden bloquearse.',
                blocked_exact_email: 'Algunos correos exactos de la lista de permitidos coinciden con una regla de bloqueo. Los correos coincidentes aún pueden bloquearse.',
                blocked_subaddressing: 'Algunas entradas de la lista de permitidos contienen un signo más (+), pero el subdireccionamiento de correo está bloqueado.',
                effectively_unusable: 'Según estas comprobaciones, es posible que la lista de permitidos actual no permita pasar ningún correo nuevo.',
            },
        },
        disposable_email: {
            title: 'Bloquear direcciones de correo electrónico desechables',
            description: 'Habilita el rechazo de cualquier intento de registro utilizando una dirección de correo desechable o de un solo uso, lo que puede prevenir el spam y mejorar la calidad del usuario.',
        },
        email_subaddressing: {
            title: 'Bloquear subdirecciones de correo electrónico',
            description: 'Habilita el rechazo de cualquier intento de registro utilizando subdirecciones de correo electrónico con un signo más (+) y caracteres adicionales (por ejemplo, usuario+alias@foo.com).',
        },
        custom_email_address: {
            title: 'Bloquear direcciones de correo electrónico personalizadas',
            description: 'Agrega reglas para impedir que dominios de correo, direcciones de correo o patrones comodín específicos se registren o vinculen mediante la interfaz de usuario. Ejemplos: bar@example.com, @example.com, foo*@example.com, *@example.com. Los dominios gmail.com y googlemail.com se tratan como equivalentes y los puntos de la parte local se ignoran, por lo que foo.bar@gmail.com coincide con foobar@googlemail.com.',
            placeholder: 'Ingresa una dirección de correo, dominio o patrón comodín',
            duplicate_error: 'La dirección de correo electrónico, el dominio o el patrón de dirección de correo con comodín ya fue agregado',
            invalid_format_error: 'Debe ser una dirección de correo electrónico válida (bar@example.com), un dominio (@example.com) o un patrón de dirección de correo con comodín (foo*@example.com, *@example.com)',
        },
    },
};
export default Object.freeze(security);
